import {Button, Group, Text} from '@mantine/core'
import {useState} from 'react'

import {useConfirmRentalsOut} from './use-confirm-rentals-out'

type ConfirmOutButtonProps = {
    rentalStintIds: string[]
    label?: string
    onConfirmed?: () => void
}

/** Confirm that equipment put on rent automatically went out. Billing dates do not change. */
export function ConfirmOutButton({
    rentalStintIds,
    label = 'Confirm out',
    onConfirmed,
}: ConfirmOutButtonProps) {
    const confirm = useConfirmRentalsOut()
    const [error, setError] = useState<string | null>(null)

    async function handleConfirm() {
        setError(null)
        try {
            await confirm.mutateAsync(rentalStintIds)
            onConfirmed?.()
        } catch (caught) {
            setError(caught instanceof Error ? caught.message : 'Could not confirm it went out')
        }
    }

    return (
        <Group gap="xs" wrap="nowrap">
            <Button
                size="compact-xs"
                variant="light"
                onClick={() => void handleConfirm()}
                loading={confirm.isPending}
            >
                {label}
            </Button>
            {error ? (
                <Text size="xs" c="red">
                    {error}
                </Text>
            ) : null}
        </Group>
    )
}
